<script>
    import R, {LOADER} from "../lib/requests";
    import {API_URL, CUSTOMER_TYPE, CUSTOMER_TYPES, PAYMENT_TYPE, PAYMENT_TYPES} from "../lib/constants";
    import {lastDateOfMonth, toFloat} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import PageHeader from "../components/PageHeader.svelte";
    import DateControl from "../components/controls/DateControl.svelte";
    import MultiSelectControl from "../components/controls/MultiSelectControl.svelte";

    export let accounts = null;
    export let transporters = null;

    const pageHeaderControls = [
        {id: 'export', name: 'EXPORT', icon: 'file-excel'},
    ];

    let search = {
        date_from: null,// '2024-01-01',
        date_to: null,// getDate('y-m-d'),
        account_id: '',
        transporter_id: '',
        customer_type: [CUSTOMER_TYPE.COMPANY],
        payment_type: [PAYMENT_TYPE.ON_ACCOUNT]
    }

    let paymentTypes = [];
    let customerTypes = [];
    let report = null;

    const initialize = () => {
        // init payment types
        Object.keys(PAYMENT_TYPE).map(key => {
            paymentTypes.push({
                id: PAYMENT_TYPE[key],
                name: PAYMENT_TYPES[PAYMENT_TYPE[key]],
                is_checked: search.payment_type.indexOf(PAYMENT_TYPE[key]) > -1 ? 1 : 0,
            });
        });

        // init customer types
        Object.keys(CUSTOMER_TYPE).map(key => {
            customerTypes.push({
                id: CUSTOMER_TYPE[key],
                name: CUSTOMER_TYPES[CUSTOMER_TYPE[key]],
                is_checked: search.customer_type.indexOf(CUSTOMER_TYPE[key]) > -1 ? 1 : 0,
            });
        });
    }

    const load = () => {
        const onSuccess = result => {
            report = result;
        }

        const onFailure = err => {
        };

        if (!validate()) {
            return;
        }

        R.handle(R.report.accountTransporter, search, onSuccess, onFailure, LOADER.POPUP);
    }

    const validate = () => {
        if (!search.date_from || !search.date_to) {
            Notifier.showError("Select dates for the report!");
            return;
        }

        if (!search.account_id) {
            Notifier.showError("Select an account for the report!");
            return;
        }

        if (!search.transporter_id) {
            Notifier.showError("Select a transporter for the report!");
            return;
        }

        if (!search.customer_type.length) {
            Notifier.showError("Select customer types for the report!");
            return;
        }

        if (!search.payment_type.length) {
            Notifier.showError("Select payment types for the report!");
            return;
        }

        return true;
    }

    const onDateFromChange = () => {
        if (!search.date_from) {
            return;
        }

        if (!search.date_to || search.date_to < search.date_from) {
            search.date_to = lastDateOfMonth(search.date_from);
        }
    }

    const onOpenTransfer = id => {
        window.open(`/app/transfer/${id}`, "_blank");
    }

    const onExport = () => {
        if (!validate()) {
            return;
        }

        const extra = `?report=account-transporter&` + new URLSearchParams(search);
        window.open(API_URL + '/export.php' + extra);
    }

    initialize();
</script>

<PageHeader title="Account Transporter Report" controls={ pageHeaderControls } on:export={ onExport }/>

<div class="panel-simple p-2 mb-4">
    <div class="row">
        <div class="col-lg-1 col-sm-3 col-6">
            <DateControl bind:value="{ search.date_from }" placeholder="from" on:change={ onDateFromChange }/>
        </div>
        <div class="col-lg-1 col-sm-3 col-6 form-group-sm">
            <DateControl bind:value="{ search.date_to }" placeholder="to"/>
        </div>
        <div class="col-lg-2 col-sm-3 col-6 form-group-sm">
            <select class="form-select" bind:value="{ search.account_id }">
                <option value="">account</option>
                {#each accounts as item}
                    <option value="{ item.id }">{ item.name }</option>
                {/each}
            </select>
        </div>
        <div class="col-lg-2 col-sm-3 col-6 form-group-sm">
            <select class="form-select" bind:value="{ search.transporter_id }">
                <option value="">transporter</option>
                {#each transporters as item}
                    <option value="{ item.id }">{ item.name }</option>
                {/each}
            </select>
        </div>
        <div class="col-lg-2 col-sm-3 col-6 form-group-sm">
            <MultiSelectControl options="{ customerTypes }" bind:value="{ search.customer_type }"
                                placeholder="customer type"/>
        </div>
        <div class="col-lg-2 col-sm-3 col-6 form-group-sm">
            <MultiSelectControl options="{ paymentTypes }" bind:value="{ search.payment_type }"
                                placeholder="payment type"/>
        </div>
        <div class="col-xl-2 col-sm-3 col-12">
            <button class="btn btn-primary btn-block" on:click={ load }>REPORT</button>
        </div>
    </div>
</div>

{#if report}
    <table class="table table-list table-list-border account-trans-list mb-5">
        <tbody>
        <tr>
            <td colspan="12">
                Period: <b>{ report.period }</b><br>
                Account: <b>{ report.account }</b><br>
                Transporter: <b>{ report.transporter }</b><br>
                Payment Type: <b>{ report.payment_type }</b><br>
                Customer Type: <b>{ report.customer_type }</b>
            </td>
        </tr>

        {#if report.vehicles.length}
            {#each report.vehicles as vehicle}
                <tr>
                    <td class="row-separator" colspan="12"></td>
                </tr>
                <tr>
                    <td colspan="12"><b>{ vehicle.licence_no }</b></td>
                </tr>
                <tr>
                    <th>Date/Time</th>
                    <th>Transport</th>
                    <th>Cust. Type</th>
                    <th class="text-center">Charge</th>
                    <th class="text-center">Transp.</th>
                    <th class="text-center">Account</th>
                    <th class="text-center">Dpt.</th>
                    <th class="text-center">Regent</th>
                    <th class="text-center">A</th>
                    <th class="text-center">K</th>
                    <th>Driver</th>
                    <th>Hotel</th>
                </tr>
                {#each vehicle.transfers as transfer}
                    <tr>
                        <td>
                            <span class="is-link" on:click={ () => onOpenTransfer(transfer.id) }>
                                { transfer.date }
                            </span>
                        </td>
                        <td>{ transfer.pickup_name } &#10140; { transfer.drop_name }</td>
                        <td>{ transfer.customer_type }</td>
                        <td class="text-center">{ toFloat(transfer.price) }</td>
                        <td class="text-center">{ toFloat(transfer.transporter_price) }</td>
                        <td class="text-center">{ toFloat(transfer.account_price) }</td>
                        <td class="text-center">{ toFloat(transfer.department_price) }</td>
                        <td class="text-center">{ toFloat(transfer.company_price) }</td>
                        <td class="text-center">{ transfer.adults }</td>
                        <td class="text-center">{ transfer.children }</td>
                        <td>{ transfer.driver }</td>
                        <td>{ transfer.hotel }</td>
                    </tr>
                {/each}
                <tr>
                    <td colspan="3"><b>Summarize</b></td>
                    <td class="text-center">{ toFloat(vehicle.total_price) }</td>
                    <td class="text-center">{ toFloat(vehicle.total_transporter_price) }</td>
                    <td class="text-center">{ toFloat(vehicle.total_account_price) }</td>
                    <td class="text-center">{ toFloat(vehicle.total_department_price) }</td>
                    <td class="text-center">{ toFloat(vehicle.total_company_price) }</td>
                    <td colspan="4"></td>
                </tr>
            {/each}
        {:else}
            <tr>
                <td colspan="12">Nothing found!</td>
            </tr>
        {/if}
        </tbody>
    </table>
{/if}

<style>
    .account-trans-list .row-separator {
        height: 10px;
        padding: 0;
        background: #f2f6f8;
    }
</style>